$shm_hitalama_map_widget_float_file $shm_hitalama_map_widget_float
	controls /
		<= Title $mol_paragraph
			dom_name <= title_dom_name \h1
			title <= name \
		^ controls_common
	sub_scrollable /
		^
		<= Size_badge $mol_view
			sub /
				<= file_size \
	controls_common /
		^ baza_download_progress_visible / <= Baza_download_progress $mol_view
			sub /
				<= Baza_download_progress_bar $mol_view
					style *
						^
						width <= baza_download_progress_width \0%
				<= Baza_download_progress_status $mol_text
					text <= baza_download_progress_status \
		^ baza_upload_progress_visible / <= Baza_upload_progress $mol_view
			sub /
				<= Baza_upload_progress_bar $mol_view
					style *
						^
						width <= baza_upload_progress_width \0%
				<= Baza_upload_progress_status $mol_text
					text <= baza_upload_progress_status \
	controls_tg /
		^ tg_send_status_visible / <= Tg_send_status $mol_text
			text <= tg_send_status \
		^ tg_send_upload_visible / <= Tg_send_upload $mol_button_minor
			title \Загрузить в tg
			click <= tg_send_upload null
	controls_audio /
		<= Title
		<= Player $shm_hitalama_audio_player
			uri <= audio_uri \
			name <= name \
		<= Size_badge
		^ controls_common
	contextmenu_body /
		^ contextmenu_unpack /
		<= Download $mol_button_download
			title \Скачать
			click <= download null
		^
	contextmenu_for *any
		js /
			<= Unpacking_embed $mol_button_minor
				title \Распаковка
				click? <=> unpacking_embed? null
		zip / <= Unpacking_embed
		csv /
			<= Unpacking $mol_button_minor
				title \Распаковка
				click? <=> unpacking? null
		parquet /
			<= Unpacking_parquet $mol_button_minor
				title \Распаковка
				click? <=> unpacking? null
